var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-button-box",class:`${_vm.type}-box-btn`},[_c('el-button',{style:(_vm.styleTextObj),attrs:{"size":_vm.size,"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click', $event)}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }